module.exports = __webpack_public_path__ + "static/img/planta.3e6849c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/esquema-en/planta.jpg
// module id = Xe9c
// module chunks = 0